import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ProfileData {
  name: string;
  email: string;
  role: string;
}

interface NotificationSettings {
  emailAlerts: boolean;
  pushNotifications: boolean;
  maintenanceUpdates: boolean;
  securityAlerts: boolean;
}

interface SecuritySettings {
  twoFactorAuth: boolean;
  sessionTimeout: string;
  apiAccess: boolean;
}

export const useSettingsData = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [saving, setSaving] = useState(false);

  const [profileData, setProfileData] = useState<ProfileData>({
    name: user?.name || '',
    email: user?.email || '',
    role: user?.role || 'user',
  });

  const [notifications, setNotifications] = useState<NotificationSettings>({
    emailAlerts: true,
    pushNotifications: false,
    maintenanceUpdates: true,
    securityAlerts: true,
  });

  const [security, setSecurity] = useState<SecuritySettings>({
    twoFactorAuth: false,
    sessionTimeout: '30',
    apiAccess: true,
  });

  const handleProfileSave = async () => {
    setSaving(true);
    try {
      // Implement profile update
      console.log('Saving profile:', profileData);
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } finally {
      setSaving(false);
    }
  };

  const handleNotificationsSave = async () => {
    setSaving(true);
    try {
      // Implement notifications update
      console.log('Saving notifications:', notifications);
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } finally {
      setSaving(false);
    }
  };

  const handleSecuritySave = async () => {
    setSaving(true);
    try {
      // Implement security settings update
      console.log('Saving security settings:', security);
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } finally {
      setSaving(false);
    }
  };

  return {
    profileData,
    setProfileData,
    notifications,
    setNotifications,
    security,
    setSecurity,
    saving,
    handleProfileSave,
    handleNotificationsSave,
    handleSecuritySave,
  };
};